export default __webpack_public_path__ + "static/sakurai-791878bee9ed74550742cb5ea58174d7.jpg";